import React, { useCallback } from "react";
import { useTimer } from "../hooks";
import { info } from "console";

interface TimerProps {
    started: boolean;
    durationSeconds: number;
    infoMessage: string;
}

const Timer: React.FC<TimerProps> = ({ started, durationSeconds, infoMessage }) => {
    const seconds = useTimer(started, durationSeconds);

    // Progress percentage
    const progress = Math.min((seconds / durationSeconds) * 100, 100);

    // Remaining countdown
    const remaining = Math.max(durationSeconds - seconds, 0);

    const formatMinutes = useCallback(
        (sec: number) => ("0" + Math.floor(sec / 60)).slice(-2),
        []
    );
    const formatSeconds = useCallback(
        (sec: number) => ("0" + (sec % 60)).slice(-2),
        []
    );

    return (
        <div className={`w-full max-w-md mx-auto mt-0 px-2 ${infoMessage ? "hidden" : ""}`}>
            {/* Progress Bar Container */}
            <div className="relative w-full h-6 bg-gray-200 rounded-full overflow-hidden shadow-sm">
                {/* Progress Fill */}
                <div
                    className={`absolute left-0 top-0  h-full ${started ? "bg-gradient-to-r from-green-400 to-green-600" : "bg-gray-400"
                        } transition-all duration-300 ease-linear`}
                    style={{ width: `${progress}%` }}
                />
                {/* Time Text (centered) */}
                {started && (
                    <span className="absolute inset-0 flex items-center justify-center text-xs font-semibold text-dark drop-shadow-sm">
                        {formatMinutes(remaining)}:{formatSeconds(remaining)}
                    </span>
                )}
            </div>
        </div>
    );
};

export default Timer;
